import { useMarketStore, type MarketCode } from '../stores/marketStore';

// Drop-in replacement for the old useMarket hook
export const useMarket = () => {
  return useMarketStore();
};

// 🚀 OPTIMIZED HOOKS - Use these instead of useMarket() for better performance!

// Only subscribes to currentMarket - won't re-render when prices change
export const useCurrentMarket = () => {
  return useMarketStore(state => state.currentMarket);
};

// Only subscribes to market info - won't re-render when prices change
export const useCurrentMarketInfo = () => {
  return useMarketStore(state => state.getCurrentMarketInfo());
};

// Only subscribes to market actions - won't re-render when state changes
export const useMarketActions = () => {
  return useMarketStore(state => ({
    changeMarket: state.changeMarket,
    updateProductPrice: state.updateProductPrice,
    bulkUpdatePrices: state.bulkUpdatePrices,
  }));
};

// Only subscribes to price utilities - won't re-render when market changes
export const useMarketPriceUtils = () => {
  return useMarketStore(state => ({
    getProductPrice: state.getProductPrice,
    formatPrice: state.formatPrice,
  }));
};

// 🎯 АРХИТЕКТУРНОЕ РЕШЕНИЕ: Подписка только на цену конкретного продукта
export const useProductPrice = (productId: string, fallbackPrice: number) => {
  return useMarketStore(
    state => state.productPrices[productId] ?? fallbackPrice
  );
};

// Только символ валюты - стабильная подписка
export const useCurrencySymbol = () => {
  return useMarketStore(
    state => state.availableMarkets[state.currentMarket]?.currencySymbol || '$'
  );
};

export type { MarketCode };
